import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { loginConGoogle, usuario } = useAuth();
  const navigate = useNavigate();
  const botonRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (usuario) navigate('/');
  }, [usuario, navigate]);

  useEffect(() => {
    if (!window.google || !botonRef.current) return;

    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: async (response) => {
        try {
          await loginConGoogle(response.credential);
          navigate('/');
        } catch (err) {
          setError(
            err.response?.data?.error || 'No se pudo iniciar sesión. Intenta de nuevo.'
          );
        }
      }
    });

    window.google.accounts.id.renderButton(botonRef.current, {
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      width: 280
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="bg-white shadow-md rounded-xl p-10 text-center max-w-sm w-full">
        <h1 className="text-xl font-bold text-slate-800 mb-6">Corporación G&F</h1>

        <div ref={botonRef} className="flex justify-center mb-4" />

        {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

        <p className="text-xs text-slate-400 mt-6">
          Acceso restringido a cuentas autorizadas del corporativo.
        </p>
      </div>
    </div>
  );
}
